/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Group, Link, Icon, ToolTip, Form, Grid, GridSet, GridItem, TextField } from '@insticator/insticator-ui'; // iui-material
import Upload from 'material/ctas/upload/upload_container';
//styles
import styles from 'pages/dashboard/account/paymentinfo/selectmethod/check/check_styles';
import injectSheet from 'react-jss';



/* ========== ~~~~~~~~~~ CHECK ~~~~~~~~~~ ========== */
class Check extends Component {
    constructor(props){
        super(props);
        this.formName = 'CHECKS';
    }

    componentDidMount(){
       if(this.props.paymentUUID) this.props.getCheckInformation( false, this.formName, this.props.paymentUUID );
    }

    handleDiscard = () => {
        this.props.discardChanges(this.formName);
    };

    // useDefaultAddress = (e)=>{
    //   !e ? this.props.updateCheckAddressWithGeneralAddress(this.props.generalStoredData, this.props.accountUUID) : this.props.clearCheckFieldsFromGeneral();
    // };

    handleFileUpload = (file) => {
        this.props.uploadFile(file, this.formName);
        this.props.handleFileUpload(file)
    };

    handleFileDiscard = () =>{
        this.props.discardFile(this.formName);
        this.props.handleFileDiscard()
    };

    render() {
        const { payTo, paymentAddress, city, zip, state, country } = this.props.fields; // defaultAddress
        return(<Form formName={this.formName} editable={this.props.editable}>
                    <Grid klass={`check ${this.props.classes.check}`}>
                        <GridSet align={`horizontal`} >
                            <GridItem type={`full`}>
                                <TextField type={`text`} name={`payTo`} value={payTo.value} valid={payTo.valid} formName={this.formName} placeholder={`Account name`} label={`Pay to`} info={``} required />
                            </GridItem>
                        </GridSet>
                        {/*<GridSet align={`horizontal`} >*/}
                            {/*<GridItem type={`full`}>*/}
                                {/*/!*<div className={`default-address`}><Toggle name={`default-address`} formName={this.formName} handleClick={this.useDefaultAddress} type={`checkbox`} color={`neutral`} /> use address from profile information</div>*!/*/}
                                {/*<Field type={`checkbox`} name={`defaultAddress`} value={defaultAddress.value} checked={defaultAddress.value} valid={defaultAddress.valid} formName={this.formName} variant={`box`} label={`use address from profile information`}  handleChange={()=>this.useDefaultAddress(defaultAddress.value)} required />*/}
                            {/*</GridItem>*/}
                        {/*</GridSet>*/}
                        <GridSet align={`horizontal`} >
                            <GridItem type={`full`}>
                                <TextField type={`text`} name={`paymentAddress`} value={paymentAddress.value} valid={paymentAddress.valid} formName={this.formName} placeholder={`Street address`} label={`Payment Address`} info={``} required />
                            </GridItem>
                        </GridSet>
                        <GridSet align={`horizontal`} >
                            <GridItem>
                                <TextField type={`text`} name={`city`} value={city.value} valid={city.valid} formName={this.formName} placeholder={`City`} label={`City`} info={``} required />
                            </GridItem>
                            <GridItem>
                                <TextField type={`text`} name={`zip`} value={zip.value} valid={zip.valid} formName={this.formName} placeholder={`Zip/Postal Code`} label={`Zip/Postal code`} info={``} required />
                            </GridItem>
                        </GridSet>
                        <GridSet align={`horizontal`} >
                            <GridItem>
                                <TextField type={`text`} name={`state`} value={state.value} valid={state.valid} formName={this.formName} placeholder={`State`} label={`State`} info={``} required />
                            </GridItem>
                            <GridItem>
                                <TextField type={`text`} name={`country`} value={country.value} valid={country.valid} formName={this.formName} placeholder={`Country`} label={`Country`} info={``} required />
                            </GridItem>
                        </GridSet>
                        <GridSet align={`horizontal`} >
                            <GridItem>
                                <Group name={`upload-form valid-${this.props.fields.form.valid}`} >
                                    <span>W9 Form <ToolTip align={`right`} action={`click`} content={<p>Please make sure you are uploading a file in PDF format (we currently do not support other file formats).</p>}><Icon name={`exclamation-circle`} /></ToolTip></span>
                                    <Upload fileName={this.props.fields.form.value.name} uploadDate={this.props.fields.form.value.updatedDate} accept={'application/pdf'} handleDiscard={this.handleFileDiscard} handleFileUpload={this.handleFileUpload}/>
                                    {/*this link will have to change based on this pages state from redux, if document is previously uploaded user will be able to download it*/}
                                    <Link text={this.props.fields.form.value.formLink ? 'Download your W9 Form' : 'Download W9 Form Template'} color={`primary`} type={`external`} action={this.props.fields.form.value.formLink ? this.props.fields.form.value.formLink : 'https://www.irs.gov/pub/irs-pdf/fw9.pdf'} icon={`arrow-down`} iconRight/>
                                </Group>
                            </GridItem>
                        </GridSet>
                    </Grid>
            </Form>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Check);
